import { render, staticRenderFns } from "./AccountPrefixValidator.vue?vue&type=template&id=69fa9b2e&scoped=true&"
import script from "./AccountPrefixValidator.vue?vue&type=script&lang=js&"
export * from "./AccountPrefixValidator.vue?vue&type=script&lang=js&"
import style0 from "./AccountPrefixValidator.vue?vue&type=style&index=0&id=69fa9b2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fa9b2e",
  null
  
)

export default component.exports